export default __webpack_public_path__ + "static/media/P306 zu P314.15aaf561.mp3";